const actions = {
  CLEAR_MESSAGE: 'CLEAR_MESSAGE',
  // START: Merchant Portal
  FETCH_ALL_MERCHANT_PORTAL: 'FETCH_ALL_MERCHANT_PORTAL',
  FETCHING_ALL_MERCHANT_PORTAL: 'FETCHING_ALL_MERCHANT_PORTAL',
  FETCH_ALL_MERCHANT_PORTAL_SUCCESS: 'FETCH_ALL_MERCHANT_PORTAL_SUCCESS',
  FETCH_ALL_MERCHANT_PORTAL_FAILED: 'FETCH_ALL_MERCHANT_PORTAL_FAILED',
  LOADING_MORE_MERCHANT_PORTAL: 'LOADING_MORE_MERCHANT_PORTAL',

  GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT: 'GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT',
  GENERATING_MERCHANT_ONBOARDING_STATUS_REPORT: 'GENERATING_MERCHANT_ONBOARDING_STATUS_REPORT',
  GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT_SUCCESS:
    'GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT_SUCCESS',
  GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT_FAILED:
    'GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT_FAILED',

  DOWNLOAD_MERCHANT_ONBOARDING_STATUS_REPORT: 'DOWNLOAD_MERCHANT_ONBOARDING_STATUS_REPORT',
  DOWNLOADING_MERCHANT_ONBOARDING_STATUS_REPORT: 'DOWNLOADING_MERCHANT_ONBOARDING_STATUS_REPORT',
  DOWNLOAD_MERCHANT_ONBOARDING_STATUS_REPORT_SUCCESS:
    'DOWNLOAD_MERCHANT_ONBOARDING_STATUS_REPORT_SUCCESS',
  DOWNLOAD_MERCHANT_ONBOARDING_STATUS_REPORT_FAILED:
    'DOWNLOAD_MERCHANT_ONBOARDING_STATUS_REPORT_FAILED',

  FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA:
    'FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA',
  FETCHING_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA:
    'FETCHING_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA',
  FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA_SUCCESS:
    'FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA_SUCCESS',
  FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA_FAILED:
    'FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA_FAILED',

  FETCH_MERCHANT_KYB_DOCUMENT_BY_ID: 'FETCH_MERCHANT_KYB_DOCUMENT_BY_ID',
  FETCHING_MERCHANT_KYB_DOCUMENT_BY_ID: 'FETCHING_MERCHANT_KYB_DOCUMENT_BY_ID',
  FETCH_MERCHANT_KYB_DOCUMENT_BY_ID_SUCCESS: 'FETCH_MERCHANT_KYB_DOCUMENT_BY_ID_SUCCESS',
  FETCH_MERCHANT_KYB_DOCUMENT_BY_ID_FAILED: 'FETCH_MERCHANT_KYB_DOCUMENT_BY_ID_FAILED',
  RESET_ACTIVE_MERCHANT_KYB_DOCUMENT_BY_ID: 'RESET_ACTIVE_MERCHANT_KYB_DOCUMENT_BY_ID',

  FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID: 'FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID',
  FETCHING_MERCHANT_KAISER_CHECK_RESULTS_BY_ID: 'FETCHING_MERCHANT_KAISER_CHECK_RESULTS_BY_ID',
  FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID_SUCCESS:
    'FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID_SUCCESS',
  FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID_FAILED:
    'FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID_FAILED',
  RESET_ACTIVE_MERCHANT_KAISER_CHECK_RESULTS_BY_ID:
    'RESET_ACTIVE_MERCHANT_KAISER_CHECK_RESULTS_BY_ID',

  FETCH_AMEND_HISTORY_MOC: 'FETCH_AMEND_HISTORY_MOC',
  FETCHING_AMEND_HISTORY_MOC: 'FETCHING_AMEND_HISTORY_MOC',
  FETCH_AMEND_HISTORY_MOC_SUCCESS: 'FETCH_AMEND_HISTORY_MOC_SUCCESS',
  FETCH_AMEND_HISTORY_MOC_FAILED: 'FETCH_AMEND_HISTORY_MOC_FAILED',

  DOWNLOAD_MERCHANT_KYB_DOCUMENT: 'DOWNLOAD_MERCHANT_KYB_DOCUMENT',
  DOWNLOADING_MERCHANT_KYB_DOCUMENT: 'DOWNLOADING_MERCHANT_KYB_DOCUMENT',
  DOWNLOAD_MERCHANT_KYB_DOCUMENT_SUCCESS: 'DOWNLOAD_MERCHANT_KYB_DOCUMENT_SUCCESS',
  DOWNLOAD_MERCHANT_KYB_DOCUMENT_FAILED: 'DOWNLOAD_MERCHANT_KYB_DOCUMENT_FAILED',

  DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS: 'DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS',
  DOWNLOADING_MERCHANT_KAISER_CHECK_RESULTS: 'DOWNLOADING_MERCHANT_KAISER_CHECK_RESULTS',
  DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS_SUCCESS: 'DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS_SUCCESS',
  DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS_FAILED: 'DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS_FAILED',

  DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT: 'DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT',
  DOWNLOADING_MERCHANT_SETTLEMENT_DOCUMENT: 'DOWNLOADING_MERCHANT_SETTLEMENT_DOCUMENT',
  DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT_SUCCESS: 'DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT_SUCCESS',
  DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT_FAILED: 'DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT_FAILED',

  DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING: 'DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING',
  DOWNLOADING_ADDENDUM_DOCUMENT_ONBOARDING: 'DOWNLOADING_ADDENDUM_DOCUMENT_ONBOARDING',
  DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING_SUCCESS: 'DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING_SUCCESS',
  DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING_FAILED: 'DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING_FAILED',

  MERCHANT_DOWNLOAD_KYB_DOCUMENT: 'MERCHANT_DOWNLOAD_KYB_DOCUMENT',
  MERCHANT_DOWNLOADING_KYB_DOCUMENT: 'MERCHANT_DOWNLOADING_KYB_DOCUMENT',
  MERCHANT_DOWNLOAD_KYB_DOCUMENT_SUCCESS: 'MERCHANT_DOWNLOAD_KYB_DOCUMENT_SUCCESS',
  MERCHANT_DOWNLOAD_KYB_DOCUMENT_FAILED: 'MERCHANT_DOWNLOAD_KYB_DOCUMENT_FAILED',

  EDIT_KYB_DOCUMENT_DATA: 'EDIT_KYB_DOCUMENT_DATA',
  EDITING_KYB_DOCUMENT_DATA: 'EDITING_KYB_DOCUMENT_DATA',
  EDIT_KYB_DOCUMENT_DATA_SUCCESS: 'EDIT_KYB_DOCUMENT_DATA_SUCCESS',
  EDIT_KYB_DOCUMENT_DATA_FAILED: 'EDIT_KYB_DOCUMENT_DATA_FAILED',

  FETCH_MERCHANT_PORTAL_BY_ID: 'FETCH_MERCHANT_PORTAL_BY_ID',
  FETCHING_MERCHANT_PORTAL_BY_ID: 'FETCHING_MERCHANT_PORTAL_BY_ID',
  FETCH_MERCHANT_PORTAL_BY_ID_SUCCESS: 'FETCH_MERCHANT_PORTAL_BY_ID_SUCCESS',
  FETCH_MERCHANT_PORTAL_BY_ID_FAILED: 'FETCH_MERCHANT_PORTAL_BY_ID_FAILED',
  RESET_ACTIVE_MERCHANT_PORTAL_BY_ID: 'RESET_ACTIVE_MERCHANT_PORTAL_BY_ID',

  FETCH_MERCHANT_ONBOARDING_LOGS: 'FETCH_MERCHANT_ONBOARDING_LOGS',
  LOADING_MORE_MERCHANT_ONBOARDING_LOGS: 'LOADING_MORE_MERCHANT_ONBOARDING_LOGS',
  FETCHING_MERCHANT_ONBOARDING_LOGS: 'FETCHING_MERCHANT_ONBOARDING_LOGS',
  FETCH_MERCHANT_ONBOARDING_LOGS_SUCCESS: 'FETCH_MERCHANT_ONBOARDING_LOGS_SUCCESS',
  FETCH_MERCHANT_ONBOARDING_LOGS_FAILED: 'FETCH_MERCHANT_ONBOARDING_LOGS_FAILED',
  RESET_MERCHANT_ONBOARDING_LOGS: 'RESET_MERCHANT_ONBOARDING_LOGS',

  FETCH_MERCHANT_ONBOARDING_DASHBOARD_LOGS: 'FETCH_MERCHANT_ONBOARDING_DASHBOARD_LOGS',
  LOADING_MORE_MERCHANT_ONBOARDING_DASHBOARD_LOGS:
    'LOADING_MORE_MERCHANT_ONBOARDING_DASHBOARD_LOGS',
  FETCHING_MERCHANT_ONBOARDING_DASHBOARD_LOGS: 'FETCHING_MERCHANT_ONBOARDING_DASHBOARD_LOGS',
  FETCH_MERCHANT_ONBOARDING_DASHBOARD_LOGS_SUCCESS:
    'FETCH_MERCHANT_ONBOARDING_DASHBOARD_LOGS_SUCCESS',
  FETCH_MERCHANT_ONBOARDING_DASHBOARD_LOGS_FAILED:
    'FETCH_MERCHANT_ONBOARDING_DASHBOARD_LOGS_FAILED',
  RESET_MERCHANT_ONBOARDING_DASHBOARD_LOGS: 'RESET_MERCHANT_ONBOARDING_DASHBOARD_LOGS',

  FETCH_MERCHANT_SETTLEMENT_LOGS: 'FETCH_MERCHANT_SETTLEMENT_LOGS',
  LOADING_MORE_MERCHANT_SETTLEMENT_LOGS: 'LOADING_MORE_MERCHANT_SETTLEMENT_LOGS',
  FETCHING_MERCHANT_SETTLEMENT_LOGS: 'FETCHING_MERCHANT_SETTLEMENT_LOGS',
  FETCH_MERCHANT_SETTLEMENT_LOGS_SUCCESS: 'FETCH_MERCHANT_SETTLEMENT_LOGS_SUCCESS',
  FETCH_MERCHANT_SETTLEMENT_LOGS_FAILED: 'FETCH_MERCHANT_SETTLEMENT_LOGS_FAILED',
  RESET_MERCHANT_SETTLEMENT_LOGS: 'RESET_MERCHANT_SETTLEMENT_LOGS',

  // END: Merchant Portal

  // START: KYB
  GENERATE_KYB_FORM: 'GENERATE_KYB_FORM',
  GENERATING_KYB_FORM: 'GENERATING_KYB_FORM',
  GENERATE_KYB_FORM_SUCCESS: 'GENERATE_KYB_FORM_SUCCESS',
  GENERATE_KYB_FORM_FAILED: 'GENERATE_KYB_FORM_FAILED',

  RESEND_KYB_FORM: 'RESEND_KYB_FORM',
  RESENDING_KYB_FORM: 'RESENDING_KYB_FORM',
  RESEND_KYB_FORM_SUCCESS: 'RESEND_KYB_FORM_SUCCESS',
  RESEND_KYB_FORM_FAILED: 'RESEND_KYB_FORM_FAILED',

  REGENERATE_KYB_FORM: 'REGENERATE_KYB_FORM',
  REGENERATING_KYB_FORM: 'REGENERATING_KYB_FORM',
  REGENERATE_KYB_FORM_SUCCESS: 'REGENERATE_KYB_FORM_SUCCESS',
  REGENERATE_KYB_FORM_FAILED: 'REGENERATE_KYB_FORM_FAILED',

  FETCH_ALL_GENERATED_KYB_FORMS: 'FETCH_ALL_GENERATED_KYB_FORMS',
  FETCHING_ALL_GENERATED_KYB_FORMS: 'FETCHING_ALL_GENERATED_KYB_FORMS',
  FETCH_ALL_GENERATED_KYB_FORMS_SUCCESS: 'FETCH_ALL_GENERATED_KYB_FORMS_SUCCESS',
  FETCH_ALL_GENERATED_KYB_FORMS_FAILED: 'FETCH_ALL_GENERATED_KYB_FORMS_FAILED',
  // END: KYB

  // START: VAT EXEMPTION

  // START: KYB Form
  STORE_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT: 'STORE_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT',
  STORING_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT: 'STORING_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT',
  STORE_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT_SUCCESS:
    'STORE_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT_SUCCESS',
  STORE_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT_FAILED: 'STORE_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT_FAILED',
  // END: VAT EXEMPTION

  // START: KYB Form
  STORE_SEC_FOR_UPLOAD: 'STORE_SEC_FOR_UPLOAD',
  STORING_SEC_FOR_UPLOAD: 'STORING_SEC_FOR_UPLOAD',
  STORE_SEC_FOR_UPLOAD_SUCCESS: 'STORE_SEC_FOR_UPLOAD_SUCCESS',
  STORE_SEC_FOR_UPLOAD_FAILED: 'STORE_SEC_FOR_UPLOAD_FAILED',

  STORE_AOI_FOR_UPLOAD: 'STORE_AOI_FOR_UPLOAD',
  STORING_AOI_FOR_UPLOAD: 'STORING_AOI_FOR_UPLOAD',
  STORE_AOI_FOR_UPLOAD_SUCCESS: 'STORE_AOI_FOR_UPLOAD_SUCCESS',
  STORE_AOI_FOR_UPLOAD_FAILED: 'STORE_AOI_FOR_UPLOAD_FAILED',

  STORE_GIS_FOR_UPLOAD: 'STORE_GIS_FOR_UPLOAD',
  STORING_GIS_FOR_UPLOAD: 'STORING_GIS_FOR_UPLOAD',
  STORE_GIS_FOR_UPLOAD_SUCCESS: 'STORE_GIS_FOR_UPLOAD_SUCCESS',
  STORE_GIS_FOR_UPLOAD_FAILED: 'STORE_GIS_FOR_UPLOAD_FAILED',

  STORE_BIR_2303_FOR_UPLOAD: 'STORE_BIR_2303_FOR_UPLOAD',
  STORING_BIR_2303_FOR_UPLOAD: 'STORING_BIR_2303_FOR_UPLOAD',
  STORE_BIR_2303_FOR_UPLOAD_SUCCESS: 'STORE_BIR_2303_FOR_UPLOAD_SUCCESS',
  STORE_BIR_2303_FOR_UPLOAD_FAILED: 'STORE_BIR_2303_FOR_UPLOAD_FAILED',

  STORE_DTI_CERTIFICATE_FOR_UPLOAD: 'STORE_DTI_CERTIFICATE_FOR_UPLOAD',
  STORING_DTI_CERTIFICATE_FOR_UPLOAD: 'STORING_DTI_CERTIFICATE_FOR_UPLOAD',
  STORE_DTI_CERTIFICATE_FOR_UPLOAD_SUCCESS: 'STORE_DTI_CERTIFICATE_FOR_UPLOAD_SUCCESS',
  STORE_DTI_CERTIFICATE_FOR_UPLOAD_FAILED: 'STORE_DTI_CERTIFICATE_FOR_UPLOAD_FAILED',

  UPLOAD_KYB_LINK_FILES: 'UPLOAD_KYB_LINK_FILES',
  UPLOADING_KYB_LINK_FILES: 'UPLOADING_KYB_LINK_FILES',
  UPLOAD_KYB_LINK_FILES_SUCCESS: 'UPLOAD_KYB_LINK_FILES_SUCCESS',
  UPLOAD_KYB_LINK_FILES_FAILED: 'UPLOAD_KYB_LINK_FILES_FAILED',

  UPLOAD_KYB_FILES: 'UPLOAD_KYB_FILES',
  UPLOADING_KYB_FILES: 'UPLOADING_KYB_FILES',
  UPLOAD_KYB_FILES_SUCCESS: 'UPLOAD_KYB_FILES_SUCCESS',
  UPLOAD_KYB_FILES_FAILED: 'UPLOAD_KYB_FILES_FAILED',

  UPLOAD_KYB_FILES_BY_MO: 'UPLOAD_KYB_FILES_BY_MO',
  UPLOADING_KYB_FILES_BY_MO: 'UPLOADING_KYB_FILES_BY_MO',
  UPLOAD_KYB_FILES_BY_MO_SUCCESS: 'UPLOAD_KYB_FILES_BY_MO_SUCCESS',
  UPLOAD_KYB_FILES_BY_MO_FAILED: 'UPLOAD_KYB_FILES_BY_MO_FAILED',

  UPLOAD_VAT_EXEMPTION_FILES: 'UPLOAD_VAT_EXEMPTION_FILES',
  UPLOADING_VAT_EXEMPTION_FILES: 'UPLOADING_VAT_EXEMPTION_FILES',
  UPLOAD_VAT_EXEMPTION_FILES_SUCCESS: 'UPLOAD_VAT_EXEMPTION_FILES_SUCCESS',
  UPLOAD_VAT_EXEMPTION_FILES_FAILED: 'UPLOAD_VAT_EXEMPTION_FILES_FAILED',

  FETCH_KYB_FORM_MERCHANT_DATA: 'FETCH_KYB_FORM_MERCHANT_DATA',
  FETCHING_KYB_FORM_MERCHANT_DATA: 'FETCHING_KYB_FORM_MERCHANT_DATA',
  FETCH_KYB_FORM_MERCHANT_DATA_SUCCESS: 'FETCH_KYB_FORM_MERCHANT_DATA_SUCCESS',
  FETCH_KYB_FORM_MERCHANT_DATA_FAILED: 'FETCH_KYB_FORM_MERCHANT_DATA_FAILED',

  STORE_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD: 'STORE_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD',
  STORING_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD: 'STORING_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD',
  STORE_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD_SUCCESS:
    'STORE_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD_SUCCESS',
  STORE_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD_FAILED: 'STORE_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD_FAILED',
  // END: KYB Form

  FETCH_ALL_ONBOARDING_USERS: 'FETCH_ALL_ONBOARDING_USERS',
  FETCHING_ALL_ONBOARDING_USERS: 'FETCHING_ALL_ONBOARDING_USERS',
  FETCH_ALL_ONBOARDING_USERS_SUCCESS: 'FETCH_ALL_ONBOARDING_USERS_SUCCESS',
  FETCH_ALL_ONBOARDING_USERS_FAILED: 'FETCH_ALL_ONBOARDING_USERS_FAILED',

  ASSIGN_MERCHANT_ONBOARDING: 'ASSIGN_MERCHANT_ONBOARDING',
  ASSIGNING_MERCHANT_ONBOARDING: 'ASSIGNING_MERCHANT_ONBOARDING',
  ASSIGN_MERCHANT_ONBOARDING_SUCCESS: 'ASSIGN_MERCHANT_ONBOARDING_SUCCESS',
  ASSIGN_MERCHANT_ONBOARDING_FAILED: 'ASSIGN_MERCHANT_ONBOARDING_FAILED',

  FETCH_REPORT_HISTORY: 'FETCH_REPORT_HISTORY',
  LOADING_MORE_REPORT_HISTORY: 'LOADING_MORE_REPORT_HISTORY',
  FETCHING_REPORT_HISTORY: 'FETCHING_REPORT_HISTORY',
  FETCH_REPORT_HISTORY_SUCCESS: 'FETCH_REPORT_HISTORY_SUCCESS',
  FETCH_REPORT_HISTORY_FAILED: 'FETCH_REPORT_HISTORY_FAILED',
  RESET_REPORT_HISTORY: 'RESET_REPORT_HISTORY',

  // Start: Account History Tab
  FETCH_ACCOUNT_HISTORY: 'FETCH_ACCOUNT_HISTORY',
  LOADING_MORE_ACCOUNT_HISTORY: 'LOADING_MORE_ACCOUNT_HISTORY',
  FETCHING_ACCOUNT_HISTORY: 'FETCHING_ACCOUNT_HISTORY',
  FETCH_ACCOUNT_HISTORY_SUCCESS: 'FETCH_ACCOUNT_HISTORY_SUCCESS',
  FETCH_ACCOUNT_HISTORY_FAILED: 'FETCH_ACCOUNT_HISTORY_FAILED',
  RESET_ACCOUNT_HISTORY: 'RESET_ACCOUNT_HISTORY',

  FETCH_ONBOARDING_LOGS: 'FETCH_ONBOARDING_LOGS',
  LOADING_MORE_ONBOARDING_LOGS: 'LOADING_MORE_ONBOARDING_LOGS',
  FETCHING_ONBOARDING_LOGS: 'FETCHING_ONBOARDING_LOGS',
  FETCH_ONBOARDING_LOGS_SUCCESS: 'FETCH_ONBOARDING_LOGS_SUCCESS',
  FETCH_ONBOARDING_LOGS_FAILED: 'FETCH_ONBOARDING_LOGS_FAILED',
  RESET_ONBOARDING_LOGS: 'RESET_ONBOARDING_LOGS',
  // End: Account History Tab

  REQUEST_MIS_AMENDMENT: 'REQUEST_MIS_AMENDMENT',
  REQUESTING_MIS_AMENDMENT: 'REQUESTING_MIS_AMENDMENT',
  REQUEST_MIS_AMENDMENT_SUCCESS: 'REQUEST_MIS_AMENDMENT_SUCCESS',
  REQUEST_MIS_AMENDMENT_FAILED: 'REQUEST_MIS_AMENDMENT_FAILED',

  APPROVE_MIS_AMENDMENT: 'APPROVE_MIS_AMENDMENT',
  APPROVING_MIS_AMENDMENT: 'APPROVING_MIS_AMENDMENT',
  APPROVE_MIS_AMENDMENT_SUCCESS: 'APPROVE_MIS_AMENDMENT_SUCCESS',
  APPROVE_MIS_AMENDMENT_FAILED: 'APPROVE_MIS_AMENDMENT_FAILED',

  ENDORSE_MIS_AMENDMENT: 'ENDORSE_MIS_AMENDMENT',
  ENDORSING_MIS_AMENDMENT: 'ENDORSING_MIS_AMENDMENT',
  ENDORSE_MIS_AMENDMENT_SUCCESS: 'ENDORSE_MIS_AMENDMENT_SUCCESS',
  ENDORSE_MIS_AMENDMENT_FAILED: 'ENDORSE_MIS_AMENDMENT_FAILED',

  REJECT_MIS_AMENDMENT: 'REJECT_MIS_AMENDMENT',
  REJECTING_MIS_AMENDMENT: 'REJECTING_MIS_AMENDMENT',
  REJECT_MIS_AMENDMENT_SUCCESS: 'REJECT_MIS_AMENDMENT_SUCCESS',
  REJECT_MIS_AMENDMENT_FAILED: 'REJECT_MIS_AMENDMENT_FAILED',

  APPROVE_SETTLEMENT_REPORT: 'APPROVE_SETTLEMENT_REPORT',
  APPROVING_SETTLEMENT_REPORT: 'APPROVING_SETTLEMENT_REPORT',
  APPROVE_SETTLEMENT_REPORT_SUCCESS: 'APPROVE_SETTLEMENT_REPORT_SUCCESS',
  APPROVE_SETTLEMENT_REPORT_FAILED: 'APPROVE_SETTLEMENT_REPORT_FAILED',

  ENDORSE_SETTLEMENT_REPORT: 'ENDORSE_SETTLEMENT_REPORT',
  ENDORSING_SETTLEMENT_REPORT: 'ENDORSING_SETTLEMENT_REPORT',
  ENDORSE_SETTLEMENT_REPORT_SUCCESS: 'ENDORSE_SETTLEMENT_REPORT_SUCCESS',
  ENDORSE_SETTLEMENT_REPORT_FAILED: 'ENDORSE_SETTLEMENT_REPORT_FAILED',

  REVIEW_SETTLEMENT_REPORT: 'REVIEW_SETTLEMENT_REPORT',
  REVIEWING_SETTLEMENT_REPORT: 'REVIEWING_SETTLEMENT_REPORT',
  REVIEW_SETTLEMENT_REPORT_SUCCESS: 'REVIEW_SETTLEMENT_REPORT_SUCCESS',
  REVIEW_SETTLEMENT_REPORT_FAILED: 'REVIEW_SETTLEMENT_REPORT_FAILED',

  REJECT_SETTLEMENT_REPORT: 'REJECT_SETTLEMENT_REPORT',
  REJECTING_SETTLEMENT_REPORT: 'REJECTING_SETTLEMENT_REPORT',
  REJECT_SETTLEMENT_REPORT_SUCCESS: 'REJECT_SETTLEMENT_REPORT_SUCCESS',
  REJECT_SETTLEMENT_REPORT_FAILED: 'REJECT_SETTLEMENT_REPORT_FAILED',

  GENERATE_SETTLEMENT_REPORT: 'GENERATE_SETTLEMENT_REPORT',
  GENERATING_SETTLEMENT_REPORT: 'GENERATING_SETTLEMENT_REPORT',
  GENERATE_SETTLEMENT_REPORT_SUCCESS: 'GENERATE_SETTLEMENT_REPORT_SUCCESS',
  GENERATE_SETTLEMENT_REPORT_FAILED: 'GENERATE_SETTLEMENT_REPORT_FAILED',

  UPDATE_MIS_RISK_LEVEL: 'UPDATE_MIS_RISK_LEVEL',
  UPDATING_MIS_RISK_LEVEL: 'UPDATING_MIS_RISK_LEVEL',
  UPDATE_MIS_RISK_LEVEL_SUCCESS: 'UPDATE_MIS_RISK_LEVEL_SUCCESS',
  UPDATE_MIS_RISK_LEVEL_FAILED: 'UPDATE_MIS_RISK_LEVEL_FAILED',

  UPDATE_PARTIAL_ONBOARDING_ALLOWED: 'UPDATE_PARTIAL_ONBOARDING_ALLOWED',
  UPDATING_PARTIAL_ONBOARDING_ALLOWED: 'UPDATING_PARTIAL_ONBOARDING_ALLOWED',
  UPDATE_PARTIAL_ONBOARDING_ALLOWED_SUCCESS: 'UPDATE_PARTIAL_ONBOARDING_ALLOWED_SUCCESS',
  UPDATE_PARTIAL_ONBOARDING_ALLOWED_FAILED: 'UPDATE_PARTIAL_ONBOARDING_ALLOWED_FAILED',

  STORE_KAISER_CHECK_RESULTS_FOR_UPLOAD: 'STORE_KAISER_CHECK_RESULTS_FOR_UPLOAD',
  STORING_KAISER_CHECK_RESULTS_FOR_UPLOAD: 'STORING_KAISER_CHECK_RESULTS_FOR_UPLOAD',
  STORE_KAISER_CHECK_RESULTS_FOR_UPLOAD_SUCCESS: 'STORE_KAISER_CHECK_RESULTS_FOR_UPLOAD_SUCCESS',
  STORE_KAISER_CHECK_RESULTS_FOR_UPLOAD_FAILED: 'STORE_KAISER_CHECK_RESULTS_FOR_UPLOAD_FAILED',

  MANAGE_KAISER_CHECK_RESULTS_FILES: 'MANAGE_KAISER_CHECK_RESULTS_FILES',
  MANAGING_KAISER_CHECK_RESULTS_FILES: 'MANAGING_KAISER_CHECK_RESULTS_FILES',
  MANAGE_KAISER_CHECK_RESULTS_FILES_SUCCESS: 'MANAGE_KAISER_CHECK_RESULTS_FILES_SUCCESS',
  MANAGE_KAISER_CHECK_RESULTS_FILES_FAILED: 'MANAGE_KAISER_CHECK_RESULTS_FILES_FAILED',

  STORE_RISK_SCORING_FILE_FOR_UPLOAD: 'STORE_RISK_SCORING_FILE_FOR_UPLOAD',
  STORING_RISK_SCORING_FILE_FOR_UPLOAD: 'STORING_RISK_SCORING_FILE_FOR_UPLOAD',
  STORE_RISK_SCORING_FILE_FOR_UPLOAD_SUCCESS: 'STORE_RISK_SCORING_FILE_FOR_UPLOAD_SUCCESS',
  STORE_RISK_SCORING_FILE_FOR_UPLOAD_FAILED: 'STORE_RISK_SCORING_FILE_FOR_UPLOAD_FAILED',

  DOWNLOAD_RISK_ASSESSMENT_DOCUMENT: 'DOWNLOAD_RISK_ASSESSMENT_DOCUMENT',
  DOWNLOADING_RISK_ASSESSMENT_DOCUMENT: 'DOWNLOADING_RISK_ASSESSMENT_DOCUMENT',
  DOWNLOAD_RISK_ASSESSMENT_DOCUMENT_SUCCESS: 'DOWNLOAD_RISK_ASSESSMENT_DOCUMENT_SUCCESS',
  DOWNLOAD_RISK_ASSESSMENT_DOCUMENT_FAILED: 'DOWNLOAD_RISK_ASSESSMENT_DOCUMENT_FAILED',

  APPROVE_KYB_PASSED: 'APPROVE_KYB_PASSED',
  APPROVING_KYB_PASSED: 'APPROVING_KYB_PASSED',
  APPROVE_KYB_PASSED_SUCCESS: 'APPROVE_KYB_PASSED_SUCCESS',
  APPROVE_KYB_PASSED_FAILED: 'APPROVE_KYB_PASSED_FAILED',

  FETCH_MERCHANT_ONBOARDING_STATUSES: 'FETCH_MERCHANT_ONBOARDING_STATUSES',
  LOADING_MORE_MERCHANT_ONBOARDING_STATUSES: 'LOADING_MORE_MERCHANT_ONBOARDING_STATUSES',
  FETCHING_MERCHANT_ONBOARDING_STATUSES: 'FETCHING_MERCHANT_ONBOARDING_STATUSES',
  FETCH_MERCHANT_ONBOARDING_STATUSES_SUCCESS: 'FETCH_MERCHANT_ONBOARDING_STATUSES_SUCCESS',
  FETCH_MERCHANT_ONBOARDING_STATUSES_FAILED: 'FETCH_MERCHANT_ONBOARDING_STATUSES_FAILED',
  PUSH_MERCHANT_ONBOARDING_STATUSES: 'PUSH_MERCHANT_ONBOARDING_STATUSES',
  RESET_MERCHANT_ONBOARDING_STATUSES: 'RESET_MERCHANT_ONBOARDING_STATUSES',

  FETCH_ONBOARDING_MERCHANTS: 'FETCH_ONBOARDING_MERCHANTS',
  LOADING_MORE_ONBOARDING_MERCHANTS: 'LOADING_MORE_ONBOARDING_MERCHANTS',
  FETCHING_ONBOARDING_MERCHANTS: 'FETCHING_ONBOARDING_MERCHANTS',
  FETCH_ONBOARDING_MERCHANTS_SUCCESS: 'FETCH_ONBOARDING_MERCHANTS_SUCCESS',
  FETCH_ONBOARDING_MERCHANTS_FAILED: 'FETCH_ONBOARDING_MERCHANTS_FAILED',
  PUSH_ONBOARDING_MERCHANTS: 'PUSH_ONBOARDING_MERCHANTS',
  RESET_ONBOARDING_MERCHANTS: 'RESET_ONBOARDING_MERCHANTS',

  FETCH_USER_ONBOARDING_LOGS: 'FETCH_USER_ONBOARDING_LOGS',
  LOADING_MORE_USER_ONBOARDING_LOGS: 'LOADING_MORE_USER_ONBOARDING_LOGS',
  FETCHING_USER_ONBOARDING_LOGS: 'FETCHING_USER_ONBOARDING_LOGS',
  FETCH_USER_ONBOARDING_LOGS_SUCCESS: 'FETCH_USER_ONBOARDING_LOGS_SUCCESS',
  FETCH_USER_ONBOARDING_LOGS_FAILED: 'FETCH_USER_ONBOARDING_LOGS_FAILED',
  PUSH_USER_ONBOARDING_LOGS: 'PUSH_USER_ONBOARDING_LOGS',
  RESET_USER_ONBOARDING_LOGS: 'RESET_USER_ONBOARDING_LOGS',

  REJECT_CONSTELLATION_MERCHANT_APPLICATION: 'REJECT_CONSTELLATION_MERCHANT_APPLICATION',
  REJECTING_CONSTELLATION_MERCHANT_APPLICATION: 'REJECTING_CONSTELLATION_MERCHANT_APPLICATION',
  REJECT_CONSTELLATION_MERCHANT_APPLICATION_SUCCESS:
    'REJECT_CONSTELLATION_MERCHANT_APPLICATION_SUCCESS',
  REJECT_CONSTELLATION_MERCHANT_APPLICATION_FAILED:
    'REJECT_CONSTELLATION_MERCHANT_APPLICATION_FAILED',

  APPROVE_CONSTELLATION_MERCHANT_APPLICATION: 'APPROVE_CONSTELLATION_MERCHANT_APPLICATION',
  APPROVING_CONSTELLATION_MERCHANT_APPLICATION: 'APPROVING_CONSTELLATION_MERCHANT_APPLICATION',
  APPROVE_CONSTELLATION_MERCHANT_APPLICATION_SUCCESS:
    'APPROVE_CONSTELLATION_MERCHANT_APPLICATION_SUCCESS',
  APPROVE_CONSTELLATION_MERCHANT_APPLICATION_FAILED:
    'APPROVE_CONSTELLATION_MERCHANT_APPLICATION_FAILED',

  REJECT_MERCHANT_APPLICATION: 'REJECT_MERCHANT_APPLICATION',
  REJECTING_MERCHANT_APPLICATION: 'REJECTING_MERCHANT_APPLICATION',
  REJECT_MERCHANT_APPLICATION_SUCCESS: 'REJECT_MERCHANT_APPLICATION_SUCCESS',
  REJECT_MERCHANT_APPLICATION_FAILED: 'REJECT_MERCHANT_APPLICATION_FAILED',

  REJECT_MO_APPLICATION: 'REJECT_MO_APPLICATION',
  REJECTING_MO_APPLICATION: 'REJECTING_MO_APPLICATION',
  REJECT_MO_APPLICATION_SUCCESS: 'REJECT_MO_APPLICATION_SUCCESS',
  REJECT_MO_APPLICATION_FAILED: 'REJECT_MO_APPLICATION_FAILED',

  ENDORSE_MO_APPLICATION: 'ENDORSE_MO_APPLICATION',
  ENDORSING_MO_APPLICATION: 'ENDORSING_MO_APPLICATION',
  ENDORSE_MO_APPLICATION_SUCCESS: 'ENDORSE_MO_APPLICATION_SUCCESS',
  ENDORSE_MO_APPLICATION_FAILED: 'ENDORSE_MO_APPLICATION_FAILED',

  REQUEST_APPROVAL_MO_APPLICATION: 'REQUEST_APPROVAL_MO_APPLICATION',
  REQUESTING_APPROVAL_MO_APPLICATION: 'REQUESTING_APPROVAL_MO_APPLICATION',
  REQUEST_APPROVAL_MO_APPLICATION_SUCCESS: 'REQUEST_APPROVAL_MO_APPLICATION_SUCCESS',
  REQUEST_APPROVAL_MO_APPLICATION_FAILED: 'REQUEST_APPROVAL_MO_APPLICATION_FAILED',

  APPROVE_MO_APPLICATION: 'APPROVE_MO_APPLICATION',
  APPROVING_MO_APPLICATION: 'APPROVING_MO_APPLICATION',
  APPROVE_MO_APPLICATION_SUCCESS: 'APPROVE_MO_APPLICATION_SUCCESS',
  APPROVE_MO_APPLICATION_FAILED: 'APPROVE_MO_APPLICATION_FAILED',

  FETCH_TEST_ACCESS_EXEMPTION_REQUESTS: 'FETCH_TEST_ACCESS_EXEMPTION_REQUESTS',
  FETCHING_TEST_ACCESS_EXEMPTION_REQUESTS: 'FETCHING_TEST_ACCESS_EXEMPTION_REQUESTS',
  FETCH_TEST_ACCESS_EXEMPTION_REQUESTS_SUCCESS: 'FETCH_TEST_ACCESS_EXEMPTION_REQUESTS_SUCCESS',
  FETCH_TEST_ACCESS_EXEMPTION_REQUESTS_FAILED: 'FETCH_TEST_ACCESS_EXEMPTION_REQUESTS_FAILED',

  FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS: 'FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS',
  FETCHING_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS: 'FETCHING_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS',
  FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS_SUCCESS:
    'FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS_SUCCESS',
  FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS_FAILED:
    'FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS_FAILED',
  RESET_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS: 'RESET_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS',

  FETCH_EXEMPTION_REQUEST_LOGS: 'FETCH_EXEMPTION_REQUEST_LOGS',
  LOADING_MORE_EXEMPTION_REQUEST_LOGS: 'LOADING_MORE_EXEMPTION_REQUEST_LOGS',
  FETCHING_EXEMPTION_REQUEST_LOGS: 'FETCHING_EXEMPTION_REQUEST_LOGS',
  FETCH_EXEMPTION_REQUEST_LOGS_SUCCESS: 'FETCH_EXEMPTION_REQUEST_LOGS_SUCCESS',
  FETCH_EXEMPTION_REQUEST_LOGS_FAILED: 'FETCH_EXEMPTION_REQUEST_LOGS_FAILED',
  RESET_EXEMPTION_REQUEST_LOGS: 'RESET_EXEMPTION_REQUEST_LOGS',

  DOWNLOAD_EXEMPTION_REQUEST_FILE: 'DOWNLOAD_EXEMPTION_REQUEST_FILE',
  DOWNLOADING_EXEMPTION_REQUEST_FILE: 'DOWNLOADING_EXEMPTION_REQUEST_FILE',
  DOWNLOAD_EXEMPTION_REQUEST_FILE_SUCCESS: 'DOWNLOAD_EXEMPTION_REQUEST_FILE_SUCCESS',
  DOWNLOAD_EXEMPTION_REQUEST_FILE_FAILED: 'DOWNLOAD_EXEMPTION_REQUEST_FILE_FAILED',

  REVIEW_EXEMPTION_REQUEST: 'REVIEW_EXEMPTION_REQUEST',
  REVIEWING_EXEMPTION_REQUEST: 'REVIEWING_EXEMPTION_REQUEST',
  REVIEW_EXEMPTION_REQUEST_SUCCESS: 'REVIEW_EXEMPTION_REQUEST_SUCCESS',
  REVIEW_EXEMPTION_REQUEST_FAILED: 'REVIEW_EXEMPTION_REQUEST_FAILED',

  ENDORSE_EXEMPTION_REQUEST: 'ENDORSE_EXEMPTION_REQUEST',
  ENDORSING_EXEMPTION_REQUEST: 'ENDORSING_EXEMPTION_REQUEST',
  ENDORSE_EXEMPTION_REQUEST_SUCCESS: 'ENDORSE_EXEMPTION_REQUEST_SUCCESS',
  ENDORSE_EXEMPTION_REQUEST_FAILED: 'ENDORSE_EXEMPTION_REQUEST_FAILED',

  APPROVE_EXEMPTION_REQUEST: 'APPROVE_EXEMPTION_REQUEST',
  APPROVING_EXEMPTION_REQUEST: 'APPROVING_EXEMPTION_REQUEST',
  APPROVE_EXEMPTION_REQUEST_SUCCESS: 'APPROVE_EXEMPTION_REQUEST_SUCCESS',
  APPROVE_EXEMPTION_REQUEST_FAILED: 'APPROVE_EXEMPTION_REQUEST_FAILED',

  REJECT_EXEMPTION_REQUEST: 'REJECT_EXEMPTION_REQUEST',
  REJECTING_EXEMPTION_REQUEST: 'REJECTING_EXEMPTION_REQUEST',
  REJECT_EXEMPTION_REQUEST_SUCCESS: 'REJECT_EXEMPTION_REQUEST_SUCCESS',
  REJECT_EXEMPTION_REQUEST_FAILED: 'REJECT_EXEMPTION_REQUEST_FAILED',

  FETCH_TOS_REQUESTS: 'FETCH_TOS_REQUESTS',
  LOADING_MORE_TOS_REQUESTS: 'LOADING_MORE_TOS_REQUESTS',
  FETCHING_TOS_REQUESTS: 'FETCHING_TOS_REQUESTS',
  FETCH_TOS_REQUESTS_SUCCESS: 'FETCH_TOS_REQUESTS_SUCCESS',
  FETCH_TOS_REQUESTS_FAILED: 'FETCH_TOS_REQUESTS_FAILED',

  FETCH_TOS_REQUESTS_SUMMARY: 'FETCH_TOS_REQUESTS_SUMMARY',
  LOADING_MORE_TOS_REQUESTS_SUMMARY: 'LOADING_MORE_TOS_REQUESTS_SUMMARY',
  FETCHING_TOS_REQUESTS_SUMMARY: 'FETCHING_TOS_REQUESTS_SUMMARY',
  FETCH_TOS_REQUESTS_SUMMARY_SUCCESS: 'FETCH_TOS_REQUESTS_SUMMARY_SUCCESS',
  FETCH_TOS_REQUESTS_SUMMARY_FAILED: 'FETCH_TOS_REQUESTS_SUMMARY_FAILED',

  FETCH_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY: 'FETCH_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY',
  LOADING_MORE_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY:
    'LOADING_MORE_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY',
  FETCHING_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY: 'FETCHING_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY',
  FETCH_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY_SUCCESS:
    'FETCH_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY_SUCCESS',
  FETCH_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY_FAILED:
    'FETCH_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY_FAILED',

  GENERATE_TOS_PRODUCTIVITY_REPORT: 'GENERATE_TOS_PRODUCTIVITY_REPORT',
  GENERATING_TOS_PRODUCTIVITY_REPORT: 'GENERATING_TOS_PRODUCTIVITY_REPORT',
  GENERATE_TOS_PRODUCTIVITY_REPORT_SUCCESS: 'GENERATE_TOS_PRODUCTIVITY_REPORT_SUCCESS',
  GENERATE_TOS_PRODUCTIVITY_REPORT_FAILED: 'GENERATE_TOS_PRODUCTIVITY_REPORT_FAILED',

  DOWNLOAD_TOS_PRODUCTIVITY_REPORT: 'DOWNLOAD_TOS_PRODUCTIVITY_REPORT',
  DOWNLOADING_TOS_PRODUCTIVITY_REPORT: 'DOWNLOADING_TOS_PRODUCTIVITY_REPORT',
  DOWNLOAD_TOS_PRODUCTIVITY_REPORT_SUCCESS: 'DOWNLOAD_TOS_PRODUCTIVITY_REPORT_SUCCESS',
  DOWNLOAD_TOS_PRODUCTIVITY_REPORT_FAILED: 'DOWNLOAD_TOS_PRODUCTIVITY_REPORT_FAILED',

  FETCH_ALL_TOS_PRODUCTIVITY_REPORT_DATA: 'FETCH_ALL_TOS_PRODUCTIVITY_REPORT_DATA',
  FETCHING_ALL_TOS_PRODUCTIVITY_REPORT_DATA: 'FETCHING_ALL_TOS_PRODUCTIVITY_REPORT_DATA',
  FETCH_ALL_TOS_PRODUCTIVITY_REPORT_DATA_SUCCESS: 'FETCH_ALL_TOS_PRODUCTIVITY_REPORT_DATA_SUCCESS',
  FETCH_ALL_TOS_PRODUCTIVITY_REPORT_DATA_FAILED: 'FETCH_ALL_TOS_PRODUCTIVITY_REPORT_DATA_FAILED',

  // START: Merchant Portal
  clearMessage: () => ({
    type: actions.CLEAR_MESSAGE
  }),

  fetchAllMerchantPortal: (payload, currentList) => ({
    type: actions.FETCH_ALL_MERCHANT_PORTAL,
    payload,
    currentList
  }),
  generateMerchantOnboardingStatusReport: payload => ({
    type: actions.GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT,
    payload
  }),

  downloadMerchantOnboardingStatusReport: id => ({
    type: actions.DOWNLOAD_MERCHANT_ONBOARDING_STATUS_REPORT,
    id
  }),

  fetchAllMerchantOnboardingStatusReportData: (payload) => ({
    type: actions.FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA,
    payload
  }),
  changeDocumentStatus: (payload, id) => ({
    type: actions.EDIT_KYB_DOCUMENT_DATA,
    payload,
    id
  }),
  downloadKYBDocument: (id, payload) => ({
    type: actions.DOWNLOAD_MERCHANT_KYB_DOCUMENT,
    id,
    payload
  }),
  downloadKaiserCheckResults: (id, payload) => ({
    type: actions.DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS,
    id,
    payload
  }),
  downloadSettlementDocument: (id, payload) => ({
    type: actions.DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT,
    id,
    payload
  }),
  downloadAddendumDocument: (id, payload) => ({
    type: actions.DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING,
    id,
    payload
  }),
  merchantDownloadKYBDocument: id => ({
    type: actions.MERCHANT_DOWNLOAD_KYB_DOCUMENT,
    id
  }),
  fetchMerchantKYBDocuments: payload => ({
    type: actions.FETCH_MERCHANT_KYB_DOCUMENT_BY_ID,
    payload
  }),

  fetchMerchantKaiserCheckResults: payload => ({
    type: actions.FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID,
    payload
  }),

  fetchAmendHistoryMOC: payload => ({
    type: actions.FETCH_AMEND_HISTORY_MOC,
    payload
  }),

  fetchMerchantPortalByID: payload => ({
    type: actions.FETCH_MERCHANT_PORTAL_BY_ID,
    payload
  }),
  // START: KYB page
  generateKYBForm: (id, payload) => ({
    type: actions.GENERATE_KYB_FORM,
    id,
    payload
  }),

  resendKYBForm: payload => ({
    type: actions.RESEND_KYB_FORM,
    payload
  }),

  regenerateKYBForm: payload => ({
    type: actions.REGENERATE_KYB_FORM,
    payload
  }),
  fetchAllGeneratedKYBForms: (payload) => ({
    type: actions.FETCH_ALL_GENERATED_KYB_FORMS,
    payload
  }),
  // END: KYB page

  getS3UrlsVATExemptionFile: payload => ({
    type: actions.STORE_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT,
    payload
  }),

  // START: Kyb Link
  getS3UrlDTICertificateFile: (bucketKey, fileName) => ({
    type: actions.STORE_DTI_CERTIFICATE_FOR_UPLOAD,
    bucketKey,
    fileName
  }),
  getS3UrlBIR2303File: (bucketKey, fileName) => ({
    type: actions.STORE_BIR_2303_FOR_UPLOAD,
    bucketKey,
    fileName
  }),

  uploadKYBLinkFiles: (urls, payload, id) => ({
    type: actions.UPLOAD_KYB_LINK_FILES,
    urls,
    payload,
    id
  }),
  // END: Kyb Link

  // START: KYB Form
  getS3UrlsSECFile: payload => ({
    type: actions.STORE_SEC_FOR_UPLOAD,
    payload
  }),
  getS3UrlsAOIFile: payload => ({
    type: actions.STORE_AOI_FOR_UPLOAD,
    payload
  }),
  getS3UrlsGISFile: payload => ({
    type: actions.STORE_GIS_FOR_UPLOAD,
    payload
  }),

  uploadKYBFiles: (urls, payload, id) => ({
    type: actions.UPLOAD_KYB_FILES,
    urls,
    payload,
    id
  }),
  uploadVATExemptionFiles: (urls, payload, id) => ({
    type: actions.UPLOAD_VAT_EXEMPTION_FILES,
    urls,
    payload,
    id
  }),
  uploadKYBFilesByMO: (urls, payload) => ({
    type: actions.UPLOAD_KYB_FILES_BY_MO,
    urls,
    payload
  }),

  fetchKYBFormMerchantDetails: payload => ({
    type: actions.FETCH_KYB_FORM_MERCHANT_DATA,
    payload
  }),

  getS3UrlsForRequiredFiles: payload => ({
    type: actions.STORE_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD,
    payload
  }),

  // END: KYB Form

  fetchMerchantOnboardingLogs: (payload, pagination) => ({
    type: actions.FETCH_MERCHANT_ONBOARDING_LOGS,
    payload,
    pagination
  }),

  fetchMerchantOnboardingDashboardLogs: (payload, pagination) => ({
    type: actions.FETCH_MERCHANT_ONBOARDING_DASHBOARD_LOGS,
    payload,
    pagination
  }),

  fetchUserOnboardingActivity: (payload) => ({
    type: actions.FETCH_USER_ONBOARDING_LOGS,
    payload,
  }),

  fetchMerchantSettlementLogs: (payload, pagination) => ({
    type: actions.FETCH_MERCHANT_SETTLEMENT_LOGS,
    payload,
    pagination
  }),

  fetchAllOnboardingUsers: () => ({
    type: actions.FETCH_ALL_ONBOARDING_USERS
  }),

  assignMerchantOnboarding: payload => ({
    type: actions.ASSIGN_MERCHANT_ONBOARDING,
    payload
  }),

  fetchAccountHistory: (payload, pagination) => ({
    type: actions.FETCH_ACCOUNT_HISTORY,
    payload,
    pagination
  }),

  fetchReportHistory: (payload, pagination) => ({
    type: actions.FETCH_REPORT_HISTORY,
    payload,
    pagination
  }),

  fetchOnboardingLogs: (payload, pagination) => ({
    type: actions.FETCH_ONBOARDING_LOGS,
    payload,
    pagination
  }),

  requestMISAmendment: payload => ({
    type: actions.REQUEST_MIS_AMENDMENT,
    payload
  }),

  approveMISAmendment: payload => ({
    type: actions.APPROVE_MIS_AMENDMENT,
    payload
  }),

  endorseMISAmendment: payload => ({
    type: actions.ENDORSE_MIS_AMENDMENT,
    payload
  }),

  rejectMISAmendment: payload => ({
    type: actions.REJECT_MIS_AMENDMENT,
    payload
  }),

  reviewSettlementReport: (urls, payload) => ({
    type: actions.REVIEW_SETTLEMENT_REPORT,
    urls,
    payload
  }),

  rejectSettlementReport: payload => ({
    type: actions.REJECT_SETTLEMENT_REPORT,
    payload
  }),

  approveSettlementReport: (urls, payload) => ({
    type: actions.APPROVE_SETTLEMENT_REPORT,
    urls,
    payload
  }),

  endorseSettlementReport: (urls, payload) => ({
    type: actions.ENDORSE_SETTLEMENT_REPORT,
    urls,
    payload
  }),

  generateSettlementReport: payload => ({
    type: actions.GENERATE_SETTLEMENT_REPORT,
    payload
  }),

  updateRiskLevel: (urls, payload) => ({
    type: actions.UPDATE_MIS_RISK_LEVEL,
    urls,
    payload
  }),

  allowPartialOnboarding: payload => ({
    type: actions.UPDATE_PARTIAL_ONBOARDING_ALLOWED,
    payload
  }),

  getS3UrlsKaiserCheckResults: (key, files) => ({
    type: actions.STORE_KAISER_CHECK_RESULTS_FOR_UPLOAD,
    key,
    files
  }),

  manageKaiserCheckResultsFiles: (urls, payload, id) => ({
    type: actions.MANAGE_KAISER_CHECK_RESULTS_FILES,
    urls,
    payload,
    id
  }),

  getS3UrlsForRiskScoringFile: (key, files) => ({
    type: actions.STORE_RISK_SCORING_FILE_FOR_UPLOAD,
    key,
    files
  }),

  downloadRiskAssessmentFile: (id, payload) => ({
    type: actions.DOWNLOAD_RISK_ASSESSMENT_DOCUMENT,
    id,
    payload
  }),

  approveKYBPassed: (payload, id) => ({
    type: actions.APPROVE_KYB_PASSED,
    payload,
    id
  }),

  fetchOnboardingMerchants: (payload) => ({
    type: actions.FETCH_ONBOARDING_MERCHANTS,
    payload
  }),

  fetchMerchantOnboardingStatuses: (payload) => ({
    type: actions.FETCH_MERCHANT_ONBOARDING_STATUSES,
    payload
  }),
  resetMerchantOnboardingStatuses: () => ({
    type: actions.RESET_MERCHANT_ONBOARDING_STATUSES
  }),

  approveConstellationMerchantApplication: payload => ({
    type: actions.APPROVE_CONSTELLATION_MERCHANT_APPLICATION,
    payload
  }),

  rejectConstellationMerchantApplication: payload => ({
    type: actions.REJECT_CONSTELLATION_MERCHANT_APPLICATION,
    payload
  }),

  rejectMerchantApplication: payload => ({
    type: actions.REJECT_MERCHANT_APPLICATION,
    payload
  }),

  rejectMOApplication: payload => ({
    type: actions.REJECT_MO_APPLICATION,
    payload
  }),

  endorseMOApplication: payload => ({
    type: actions.ENDORSE_MO_APPLICATION,
    payload
  }),

  requestForApprovalMOApplication: payload => ({
    type: actions.REQUEST_APPROVAL_MO_APPLICATION,
    payload
  }),

  approveMOApplication: payload => ({
    type: actions.APPROVE_MO_APPLICATION,
    payload
  }),

  fetchTestAccessExemptionRequests: (payload) => ({
    type: actions.FETCH_TEST_ACCESS_EXEMPTION_REQUESTS,
    payload
  }),

  fetchTestAccessExemptionRequestDetails: payload => ({
    type: actions.FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS,
    payload
  }),

  resetTestAccessExemptionRequestDetails: () => ({
    type: actions.RESET_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS
  }),

  fetchExemptionRequestLogs: (payload, pagination) => ({
    type: actions.FETCH_EXEMPTION_REQUEST_LOGS,
    payload,
    pagination
  }),

  downloadExemptionRequestFile: (attachmentId, exemptionRequestId) => ({
    type: actions.DOWNLOAD_EXEMPTION_REQUEST_FILE,
    attachmentId,
    exemptionRequestId
  }),

  reviewExemptionRequest: payload => ({
    type: actions.REVIEW_EXEMPTION_REQUEST,
    payload
  }),

  endorseExemptionRequest: payload => ({
    type: actions.ENDORSE_EXEMPTION_REQUEST,
    payload
  }),

  approveExemptionRequest: payload => ({
    type: actions.APPROVE_EXEMPTION_REQUEST,
    payload
  }),

  rejectExemptionRequest: payload => ({
    type: actions.REJECT_EXEMPTION_REQUEST,
    payload
  }),

  fetchTOSRequests: (payload) => ({
    type: actions.FETCH_TOS_REQUESTS,
    payload,
  }),

  fetchTOSRequestsSummary: payload => ({
    type: actions.FETCH_TOS_REQUESTS_SUMMARY,
    payload
  }),

  fetchTOSRequestsSpecialistProductivity: payload => ({
    type: actions.FETCH_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY,
    payload
  }),

  generateTOSProductivityReport: payload => ({
    type: actions.GENERATE_TOS_PRODUCTIVITY_REPORT,
    payload
  }),

  downloadTOSProductivityReport: payload => ({
    type: actions.DOWNLOAD_TOS_PRODUCTIVITY_REPORT,
    payload
  }),

  fetchAllTOSProductivityReportData: (payload) => ({
    type: actions.FETCH_ALL_TOS_PRODUCTIVITY_REPORT_DATA,
    payload
  })

  // END: Merchant Portal
};
export default actions;
